import React, { Component } from 'react'
import PropTypes from 'prop-types'

import SVG from './SVG'

class IosBaseballOutline extends Component {

  constructor(props) {
    super(props)
    this.state = {classNames: [], animationActive: false}
    this._getClasses = this._getClasses.bind(this)
  }

  render() {
    const style = {
      ...this.props.style,
      color: this.props.color,
      fontSize: this.props.fontSize,
    }

    return (
      <SVG
        style={this.props.style}
        className={this._getClasses()}
        fill={this.props.color}
        width={this.props.fontSize}
        height={this.props.fontSize}
        viewBox="0 0 1024 1024"
        onClick={this.props.onClick}
        rotate={this.props.rotate ? 1 : 0}
        shake={this.props.shake ? 1 : 0}
        beat={this.props.beat ? 1 : 0}
      >
        <path d="M925.372 558.738c0.264-2.364 0.514-4.73 0.738-7.108 0.008-0.076 0.014-0.156 0.022-0.234 1.218-12.97 1.868-26.106 1.868-39.396 0-229.726-186.26-416-416-416-15.902 0-31.584 0.924-47.024 2.662-0.178 0.020-0.36 0.036-0.54 0.056 0 0.002 0 0.004 0 0.006-194.022 22.094-347.552 177.674-366.458 372.65-0.002 0-0.006 0-0.008 0-0.144 1.496-0.262 2.994-0.39 4.492-0.272 3.152-0.506 6.314-0.706 9.486-0.052 0.836-0.112 1.67-0.16 2.508-0.128 2.242-0.232 4.49-0.326 6.742-0.022 0.562-0.042 1.124-0.064 1.686-0.194 5.214-0.324 10.448-0.324 15.712 0 229.726 186.274 416 416 416 5.254 0 10.478-0.13 15.686-0.324 0.586-0.022 1.172-0.042 1.756-0.066 2.22-0.092 4.438-0.196 6.648-0.32 0.908-0.050 1.812-0.116 2.718-0.172 3.208-0.206 6.402-0.444 9.59-0.72 1.408-0.122 2.82-0.23 4.226-0.368 0-0.002 0-0.006 0-0.008 194.988-18.904 350.558-172.432 372.652-366.458 0.002 0 0.004 0 0.008 0 0.032-0.274 0.056-0.55 0.088-0.826zM893.33 512c0 5.136-0.132 10.244-0.334 15.332-20.668-0.936-41.104-3.38-61.228-7.328l12.22-38.112-30.464-9.768-12.976 40.47c-15.182-4.224-30.16-9.302-44.884-15.276-9.952-4.036-19.702-8.446-29.25-13.208l23.036-34.006-26.494-17.948-24.718 36.492c-24.482-14.7-47.406-31.954-68.61-51.624l29.46-29.46-22.626-22.626-29.46 29.46c-19.11-20.594-35.928-42.816-50.35-66.508l36.974-25.044-17.944-26.492-34.648 23.47c-5.194-10.262-9.996-20.75-14.348-31.48-5.686-14.018-10.552-28.268-14.654-42.704l41.624-13.346-9.77-30.468-39.422 12.64c-4.208-20.846-6.82-42.028-7.792-63.458 5.088-0.202 10.194-0.334 15.33-0.334 210.262-0.004 381.328 171.064 381.328 381.326zM130.674 512c0-2.634 0.046-5.258 0.1-7.878 18.128 1.118 36.078 3.374 53.782 6.818l-14.23 44.382 30.47 9.77 15-46.782c15.384 4.256 30.56 9.392 45.476 15.442 10.35 4.198 20.478 8.808 30.394 13.792l-26.81 39.58 26.492 17.946 28.438-41.984c24.076 14.558 46.64 31.586 67.53 50.966l-33.706 33.706 22.626 22.628 33.708-33.708c19.936 21.488 37.4 44.738 52.228 69.592l-41.506 28.116 17.944 26.492 38.946-26.38c4.566 9.222 8.8 18.634 12.694 28.232 6.322 15.59 11.668 31.458 16.032 47.556l-45.664 14.64 9.768 30.466 43.062-13.806c3.216 17.012 5.358 34.244 6.43 51.644-2.622 0.052-5.244 0.1-7.878 0.1-210.26-0.002-381.328-171.070-381.326-381.33zM551.786 891.258c-1.242-19.948-3.822-39.822-7.718-59.492l48.2-15.454-9.768-30.464-45.792 14.682c-7.892-28.83-18.712-57.020-32.468-84.108l40.344-27.328-17.946-26.492-37.976 25.724c-15.776-26.188-34.466-51.104-56.080-74.29l34.162-34.162-22.626-22.626-34.164 34.162c-22.576-21.042-46.786-39.32-72.216-54.828l25.392-37.486-26.492-17.944-26.892 39.7c-27.096-13.948-55.318-24.934-84.188-32.988l14.316-44.65-30.47-9.77-15.040 46.904c-20.362-4.136-40.954-6.848-61.62-8.134 18.336-176.074 156.984-316.908 332.046-338.622 1.148 23.716 4.19 47.352 9.086 70.678l-51.87 16.632 9.77 30.468 49.806-15.97c8.090 28.288 19.008 55.934 32.772 82.492l-44.644 30.242 17.946 26.492 42.472-28.77c15.376 25.056 33.47 48.91 54.232 71.18l-38.408 38.408 22.626 22.628 38.408-38.41c22.894 21.338 47.47 39.842 73.294 55.49l-29.11 42.972 26.496 17.948 30.656-45.256c26.56 13.578 54.2 24.31 82.458 32.236l-16.336 50.954 30.464 9.768 17.050-53.18c22.602 4.624 45.488 7.508 68.448 8.62-21.712 175.060-162.546 313.706-338.62 332.044z"></path>
      </SVG>
    )
  }

  _getClasses() {
    return [...this.state.classNames, this.props.className].join(' ')
  }

  _getPathByIconName() {
    let icon = icons.find(icon => icon.tags[0] === this.props.icon)
    if (icon) return icon.paths.join(' ')
    return ''
  }

}


IosBaseballOutline.defaultProps = {
  // style
  style: {},
  color: '#000000',
  fontSize: '22px',

  // animation
  shake: false,
  beat: false,
  rotate: false,
}


IosBaseballOutline.propTypes = {
  // style
  style: PropTypes.object,
  color: PropTypes.string,
  fontSize: PropTypes.string,

  // animation
  shake: PropTypes.bool,
  beat: PropTypes.bool,
  rotate: PropTypes.bool,

  // functions
  onClick: PropTypes.func
}


export default IosBaseballOutline
